import $ from 'jquery'

export function SmartAlbumsOverview() {
  let PWS;
  PWS = typeof (PWS) === 'undefined' ? {} : PWS;
  PWS.isTabletScreenSize = document.documentElement.clientWidth + window.scrollbarWidth < 1280 && document.documentElement.clientWidth >= 768;
  PWS.isMobileScreenSize = document.documentElement.clientWidth < 768;
  PWS.smallHeightScreenSize = document.documentElement.clientHeight < 756;

  let withBanner = $('.sale-banner').length > 0;
  let headerHeight = $('.internal-sub-header').height();

  // Album Section animation on scroll
  function scrollableSections() {
    if (
      $('.sa-2025__album__sections__item').length > 0 &&
      !PWS.isTabletScreenSize &&
      !PWS.isMobileScreenSize
    ) {
      let $container = $('.sa-2025__album__sections');
      let $items = $('.sa-2025__album__sections__item');
      let $f = $('.sa-2025__album__sections__item:first-child');
      let scrollTop = (withBanner) ? $(window).scrollTop() + headerHeight + $('.sale-banner').height() : $(window).scrollTop() + headerHeight;
      let viewportHeight = $(window).height() - headerHeight;

      // First item show animation
      if (scrollTop >= $container.offset().top - viewportHeight / 1.5) {
        $('.sa-2025__album__sections__item:first-child').addClass('-show');
      } else {
        $('.sa-2025__album__sections__item:first-child').removeClass('-show');
      }

      // Fix and unfix container if it is in viewport or not
      if (scrollTop >= ($f.offset().top + $f.outerHeight() / 2) - ($(window).height() / 2 - headerHeight / 2)) {
        $container.addClass('-fixed');
      } else {
        $container.removeClass('-fixed');
      }

      // Unfix if it is above of viewport
      if ($container[0].getBoundingClientRect().bottom - $f.find('.sa-2025__album__sections__item__video')[0].getBoundingClientRect().bottom <= 120) {
        $container.removeClass('-fixed');
      }

      // Animation of the each item
      $items.each(function() {
        if ($(this).index() < $items.length) {
          if (
            (scrollTop >= $(this).offset().top - viewportHeight / 2) &&
            (scrollTop < $(this).offset().top - viewportHeight / 2 + $(this).outerHeight())
          ) {
            $items.not(':nth-child(' + $(this).index() + ')').removeClass('-in-viewport');
            if (!$(this).hasClass('-in-viewport')) {
              $(this).addClass('-in-viewport');
            }
          } else {
            if ($(this).hasClass('-in-viewport') && $(this).index() + 1 !== $items.length) {
              $(this).removeClass('-in-viewport');
            }
          }
        }
      });
    }
  }

  $(window).on('scroll.pxtrigger', function () {
    scrollableSections();
  });

  // Toggler in the "Control Every Design Element" section
  if ($('.sa-2025__design__sections').length > 0) {
    let $container = $('.sa-2025__design__sections');
    let $videos = $container.find('.sa-2025__design__sections__videos').find('.sa-2025__design__sections__videos__item');
    let $items = $container.find('.sa-2025__design__sections__content').find('.sa-2025__design__sections__content__item');

    $items.each(function() {
      let $e = $(this);
      let $trigger = $e.find('.sa-2025__design__sections__content__item__title');
      let $video = $videos.eq($e.index());
      let $parent = $e.closest('.sa-2025__design__sections__content__item');

      $trigger.on('click', function() {
        if (!$e.hasClass('-show')) {
          // Stop video and reset to 00:00 time mark
          $videos.each(function() {
            let video = $(this).find('video')[0];
            if (video) {
              video.pause();
              video.currentTime = 0;
            }
          });

          $items.removeClass('-show');
          $e.addClass('-show');

          $videos.removeClass('-show');
          $video.addClass('-show');

          // Play visible video
          let activeVideo = $video.find('video')[0];
          if (activeVideo) {
            activeVideo.play();
          }

          if (PWS.isTabletScreenSize || PWS.isMobileScreenSize) {
            setTimeout(() => {
              $('html, body').animate({
                scrollTop: $parent.offset().top - 110
              }, 300);
            }, 300);
          }
        }
      });
    });
  }

  // Album Section animation on scroll
  let point = ($('.sa-2025__perfect__image__pic-main').offset().top + $('.sa-2025__perfect__image__pic-main').outerHeight() / 2) - ($(window).height() / 2 - headerHeight / 2);

  function propertyProgress(start, end, progress) {
    return start + (end - start) * (progress / 100);
  }

  function perfectAnimation(type) {
    if (
      $('.sa-2025__perfect__image').length > 0 &&
      !PWS.isTabletScreenSize &&
      !PWS.isMobileScreenSize
    ) {
      let $container = $('.sa-2025__perfect__image');
      let $scrollable = $('.sa-2025__perfect__scrollable');
      let $image = $('.sa-2025__perfect__image__pic-main');
      let $imageSmall = $('.sa-2025__perfect__image__pic-small__img');
      let $imageSmallWrapper = $('.sa-2025__perfect__image__pic-small');
      let $inner = $('.inner.-after-image');
      let $comment = $('.sa-2025__perfect__image__comment');

      let scrollTop = (withBanner) ? $(window).scrollTop() + headerHeight + $('.sale-banner').height() : $(window).scrollTop() + headerHeight;
      let viewportHeight = $container.height();

      let elementOffset = $scrollable.offset().top;
      let elementHeight = $scrollable.height();
      let startPoint = elementOffset - viewportHeight + viewportHeight * 1.5;
      let endPoint = elementOffset + elementHeight - viewportHeight;

      let progress = 0;

      // Calculate animation progress
      if (scrollTop >= startPoint && scrollTop <= endPoint) {
        progress = ((scrollTop - startPoint) / (endPoint - startPoint)) * 100;

        if (!$image.hasClass('-no-shadow')) $image.addClass('-no-shadow');
      } else if (scrollTop > endPoint) {
        progress = 100;

        if ($image.hasClass('-no-shadow')) $image.removeClass('-no-shadow');
      }

      progress = Math.max(0, Math.min(100, progress));

      // Control height
      let progressHeight = propertyProgress(401, $(window).height() + headerHeight, progress);

      // Fix container if it's in viewport and unfix if it's not in viewport
      if (scrollTop >= point) {
        if (!$container.hasClass('-fixed')) {
          $container.addClass('-fixed');
        }

        // Cloud Proofing title
        $inner.css({
          'margin-top': progressHeight / 2 + 60 + 'px',
          'opacity': propertyProgress(1, 0, progress * 2)
        });
      } else {
        if ($container.hasClass('-fixed')) {
          $container.removeClass('-fixed');

          // Cloud Proofing title
          $inner.css({
            'margin-top': 0,
            'opacity': 1
          });
        }
      }

      // Action here (main image animation)
      $comment.css({
        'opacity': propertyProgress(1, 0, progress * 12)
      });

      $container.css({
        'width': propertyProgress(802, $(window).width() * 1.1, progress) + 'px',
        'margin-left': '-' + propertyProgress(802, $(window).width() * 1.1, progress) / 2 + 'px'
      });

      $image.css({
        'height': progressHeight + 'px',
        'margin-top': '-' + progressHeight / 2 + 'px',
        'box-shadow': '0 ' + propertyProgress(1, 0, progress) + 'px ' + propertyProgress(14, 0, progress) + 'px 0 rgba(0, 0, 0, 0.12), 0 ' + propertyProgress(5, 0, progress) + 'px ' + propertyProgress(8, 0, progress) + 'px ' + propertyProgress(-1, 0, progress) + 'px rgba(0, 0, 0, 0.14)',
        'will-change': 'top, height, box-shadow'
      });

      $image.find('img').css({
        'transform': 'scale(' + propertyProgress(1.7, 1, progress) + ') rotate(' + propertyProgress(3.2, 0, progress) + 'deg) translate3d(' + propertyProgress(-7, 0, progress) + 'px, ' + propertyProgress(35, 0, progress) + 'px, 0)',
        'will-change': 'transform !important'
      });

      if (type === 'scroll') {
        $imageSmallWrapper.css({
          'height': progressHeight + 2 + 'px',
          'margin-top': '-' + (progressHeight + 2) / 2 + 'px',
          'filter': 'blur(' + propertyProgress(0, 30, progress) + 'px)'
        });

        $imageSmall.css({
          'transform': 'scale(' + propertyProgress(1, 0.7, progress) + ') rotate(' + propertyProgress(0, 5, progress * 1.5) + 'deg) translate3d(' + propertyProgress(0, $(window).width() * 0.04, progress) + 'px, ' + propertyProgress(0, $(window).height() / 7, progress) + 'px, 0)',
          'will-change': 'opacity, transform !important',
          'opacity': propertyProgress(1, 0, progress * 5)
        });
      }
    }
  }

  perfectAnimation('init');

  $(window).on('scroll.pxtrigger', function () {
    perfectAnimation('scroll');
  });

  // Cloud Proofing image fix
  $('a').on('click', function() {
    if ($(this).attr('href').includes('smartalbums')) {
      $('.sa-2025__perfect__image').removeClass('-fixed');
    }
  });

  // Process anchors links
  const hash = window.location.hash;

  if (hash) {
    setTimeout(() => {
      $('html, body').animate({
        scrollTop: $(hash).offset().top - headerHeight
      });
    }, 300);
  }
}
